import { useState, useEffect, useRef } from "react";
import { getLayoutWidth } from "@/shared/utils/layoutViewport";

export const useSummaryHeight = () => {
  const [summaryHeight, setSummaryHeight] = useState<number>(0);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const summaryRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateHeight = () => {
      const width = getLayoutWidth();
      if (summaryRef.current && width >= 640 && width <= 768) {
        setSummaryHeight(summaryRef.current.clientHeight);
      } else if (width <= 640) {
        setSummaryHeight(0);
      } else if (width <= 1366) {
        // Laptop and desktop windows below the `desktop` breakpoint. Touch tablets
        // (iPad Pro, iPad Air, ...) never reach here: getLayoutWidth reports them as 768px.
        setSummaryHeight(56);
      } else {
        setSummaryHeight(86);
      }
    };

    const updateMobile = () => {
      // Touch tablets count as mobile via getLayoutWidth, whatever their real width.
      setIsMobile(getLayoutWidth() <= 1024);
    };

    updateHeight();
    updateMobile();

    const handleResize = () => {
      updateHeight();
      updateMobile();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { summaryHeight, isMobile, summaryRef };
};
